module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Key_16"],"path":[{"$":{"d":"M4,6.2A1.8,1.8,0,1,1,2.2,8,1.8,1.8,0,0,1,4,6.2M7.34,7a3.5,3.5,0,1,0,0,2H10v2h2V9h1v3.5h2V9h1V7Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Key_16.svg
// module id = +djn
// module chunks = 1